const ReplicateStatus = {
  NOT_INITIATED: 'not_initiated',
  INITIATED: 'initiated',
  STARTED: 'started',
  FAILED: 'failed',
  FINISHED: 'finished',
};

export { ReplicateStatus };
